import { ACTIONS_TYPES } from 'app/automations/automation-helpers-actions';

// Add Contact actions that act on an existing contact instead of creating one, so Update mode saves them.
export const UPDATE_SAFE_ADD_CONTACT_ACTIONS: ReadonlyArray<string> = [ACTIONS_TYPES.VoyadoUpdateConsentPreferences];
